import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './styles/theme.css';
import './index.css';
import App from './App';

// Настройка axios baseURL
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

// Добавляем интерцептор для автоматического добавления токена авторизации
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Язык интерфейса: по нему API выбирает язык ошибок и сообщений
    config.headers['Accept-Language'] = localStorage.getItem('language') || 'ru';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для обработки ошибок авторизации
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Проверяем, не является ли это ошибкой от ROUVY API
      const isRouvyError = error.config?.url?.includes('/api/rouvy/');
      
      // Если это ошибка авторизации в нашем API (не ROUVY), разлогиниваем
      if (!isRouvyError) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);